import React, { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { IDButton } from "@/marketing/brand";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { verifyEmail, user } = useAuth();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | success | error
  const [msg, setMsg] = useState("");
  const token = params.get("token");

  useEffect(() => {
    let done = false;
    (async () => {
      if (!token) { setState("error"); setMsg("This verification link is missing its token."); return; }
      try { await verifyEmail(token); if (!done) setState("success"); }
      catch (e) { if (!done) { setState("error"); setMsg(e?.response?.data?.detail || "This link is invalid or has expired."); } }
    })();
    return () => { done = true; };
  }, [token]);

  return (
    <AuthShell title="Email verification">
      <div className="rounded-2xl border border-[var(--id-mist)] bg-white p-8 text-center" data-testid="verify-email-status">
        {state === "loading" && (<><Loader2 className="mx-auto h-10 w-10 animate-spin text-[var(--id-gold)]" /><p className="id-sans mt-4 text-[15px] text-[var(--id-charcoal)]/70">Confirming your email…</p></>)}
        {state === "success" && (<><CheckCircle2 className="mx-auto h-12 w-12 text-[hsl(152_35%_40%)]" /><h2 className="id-serif mt-4 text-2xl text-[var(--id-charcoal)]">You're verified.</h2><p className="id-sans mt-2 text-[15px] text-[var(--id-charcoal)]/70">Your email is confirmed. Welcome to a life lived on purpose.</p><div className="mt-6"><IDButton as="button" onClick={() => navigate(user ? "/dashboard" : "/login")} variant="solid" testid="verify-continue">{user ? "Go to dashboard" : "Sign in"}</IDButton></div></>)}
        {state === "error" && (<><XCircle className="mx-auto h-12 w-12 text-[hsl(0_50%_50%)]" /><h2 className="id-serif mt-4 text-2xl text-[var(--id-charcoal)]">Link problem</h2><p className="id-sans mt-2 text-[15px] text-[var(--id-charcoal)]/70">{msg}</p><div className="mt-6"><IDButton to={user ? "/dashboard" : "/login"} variant="ghost">{user ? "Back to dashboard" : "Back to sign in"}</IDButton></div></>)}
      </div>
    </AuthShell>
  );
}
